import { render, staticRenderFns } from "./AbkGuide.vue?vue&type=template&id=370f7d18&scoped=true"
import script from "./AbkGuide.vue?vue&type=script&lang=js"
export * from "./AbkGuide.vue?vue&type=script&lang=js"
import style0 from "./AbkGuide.vue?vue&type=style&index=0&id=370f7d18&prod&rel=stylesheet%2Fless&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370f7d18",
  null
  
)

export default component.exports